// 订单状态文案
export const orderStatusCopy: ReadonlyArray<string> = [
    '开始',
    '待确认',
    '待发货',
    '已发货',
    '已取消',
    '已完成', // 5
    '退货中',
    '退货中',
    '退货中',
    '退货失败',
    '退货中', // 10
    '退货中',
    '退货成功',
    '退货中',
    '退货成功',
    '取消退货', // 15
    '退款中',
    '退款中',
    '退款中',
    '退款中',
    '退款失败', // 20
    '退款成功',
    '退货成功',
    '退货中',
    '退货成功'
];

// 支付文案
export const payCopy: ReadonlyArray<string> = ['货到付款', '微信支付', '支付宝'];

// 支付类型
export enum PayType {
    COD, // cash on delivery
    WECHAT,
    ALIPAY
}

export const cancelReason = [
    { name: '我不想买了', value: '我不想买了' },
    { name: '信息填写错误，重新拍', value: '信息填写错误，重新拍' },
    { name: '价格没有别的平台便宜', value: '价格没有别的平台便宜' }
];

export default {
    orderStatusCopy,
    payCopy,
    PayType,
    cancelReason
};
